import { PartnerDuplicatesContentMessages } from 'legacy/lut/components/widgets/public/partnerDuplicates/components/partnerDuplicatesContent/partnerDuplicatesRow/expandedRowContent/partnerDuplicatesContentMessages/PartnerDuplicatesContentMessages'
import { useMemo } from 'react'

import { IExpandedRowContent } from './models'
import { PartnerDuplicatesContentActions } from './partnerDuplicatesContentActions/PartnerDuplicatesContentActions'
import { PartnerDuplicatesDiff } from './partnerDuplicatesDiff/PartnerDuplicatesDiff'

import styles from './ExpandedRowContent.module.scss'

export const ExpandedRowContent = ({
  searchResult,
  contentActions,
  contentMessages,
  tableAdditionalColumns,
  sortDifference,
  styleClasses,
}: IExpandedRowContent) => {
  const { difference, partner } = searchResult

  const sortedDifference = useMemo(
    () => [...difference].sort(sortDifference),
    [difference, sortDifference]
  )

  return (
    <div className={styles.root}>
      <div>
        <PartnerDuplicatesDiff
          difference={sortedDifference}
          tableAdditionalColumns={tableAdditionalColumns}
          partnerId={partner.partnerId}
          styleClasses={styleClasses}
        />
      </div>
      <div className={styles.actions}>
        <PartnerDuplicatesContentMessages
          partner={partner}
          searchResult={searchResult}
          contentMessages={contentMessages}
        />
        <PartnerDuplicatesContentActions
          partner={partner}
          searchResult={searchResult}
          contentActions={contentActions}
        />
      </div>
    </div>
  )
}
